import { cn } from '@xhubio-saas/core-frontend/ui-components'

interface PdfApiLogoProps {
  className?: string
  size?: number
  showText?: boolean
}

/**
 * pdf-api brand mark: a document sheet with a folded corner and a "PDF"
 * band, drawn inline as SVG in the brand indigo (--primary #4f46e5).
 *
 * Deliberately NOT an <img>: the forked invoice-api asset
 * (public/icon_transparent.png) is a euro-coin graphic — money/invoice
 * branding that has no place on a generic PDF-rendering product. The inline
 * SVG keeps the logo self-contained (no binary asset, crisp at any size).
 */
export function PdfApiLogo({ className, size = 60, showText = true }: PdfApiLogoProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="pdf-api logo"
      >
        <title>pdf-api</title>
        {/* page body */}
        <path
          d="M13 5h16l8 8v26a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4Z"
          fill="#eef2ff"
          stroke="#4f46e5"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {/* folded corner */}
        <path
          d="M29 5v8h8"
          fill="#c7d2fe"
          stroke="#4f46e5"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {/* content lines */}
        <path d="M15 19h12M15 23h14" stroke="#a5b4fc" strokeWidth="2" strokeLinecap="round" />
        {/* PDF band */}
        <rect x="9" y="28" width="24" height="11" rx="2.5" fill="#4f46e5" />
        <text
          x="21"
          y="36"
          textAnchor="middle"
          fontSize="7.5"
          fontWeight="700"
          fontFamily="Arial, Helvetica, sans-serif"
          fill="#ffffff"
        >
          PDF
        </text>
      </svg>

      {showText && (
        <span className="text-xl">
          <span className="font-bold">pdf-api</span>
          <span className="font-normal text-muted-foreground">.xhub</span>
          <span className="font-normal text-muted-foreground"> Console</span>
        </span>
      )}
    </div>
  )
}
